import React from "react";
import LazyLoad from "react-lazy-load";
import HubspotForm from "react-hubspot-form";
import "../../../styles/banners.css";

function CorpGuideBannerOnScroll({ handleCloseScPopup }) {
    return (
        <div className="h-100 popup-on-scroll">
            <div className="closeScrollPopup" onClick={handleCloseScPopup}>
                &#10005;
            </div>
            <div className="row spacing h-100 align-items-center">
                <div className="col-xs-12 col-sm-12 col-md-7 col-lg-7 new-exit-popup-wrapper blured-bg-popup">
                    <LazyLoad offsetVertical={1000}>
                        <img
                            style={{
                                position: "absolute",
                                top: "-5px",
                                right: "-2px",
                            }}
                            className="w-25"
                            src="https://res.cloudinary.com/vantagecircle/image/upload/gatsbycms/uploads/2024/04/Group-5.webp"
                            alt="eBook"
                        />
                    </LazyLoad>
                    <div>
                        <h2 className="text-white">
                            The Ultimate Guide <br /> To Corporate Wellness
                            Programs
                        </h2>
                        <p className="text-white h6 mb-4">
                            <small>
                                {" "}
                                A comprehensive guide for launching successful
                                and engaging employee wellness programs that
                                foster employee health and wellness.
                            </small>
                        </p>
                        <LazyLoad offsetVertical={1000}>
                            <div className="hubspot-wrapper">
                                <HubspotForm
                                    portalId="6153052"
                                    formId="17edae16-be2c-4576-98d7-acfd023b84e6"
                                    onSubmit={() => console.log("Submit!")}
                                    onReady={(form) =>
                                        console.log("Form ready!")
                                    }
                                    loading={
                                        <div
                                            style={{
                                                color: "white",
                                                textAlign: "center",
                                            }}
                                        >
                                            Loading...
                                        </div>
                                    }
                                />
                            </div>
                        </LazyLoad>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CorpGuideBannerOnScroll;
